import axios from "../utils/axiosConfig";

const newsletterService = {
    getAll: async (params = {}) => {
        try {
            const response = await axios.get("/newsletters", { params });
            return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },
    
    getById: async (id) => {
        try {
          const response = await axios.get(`/newsletters/${id}`);
          return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },

    create: async (data) => {
        return axios.post("/newsletters", data);
    },

    update: async (id, data) => {
        return axios.put(`/newsletters/${id}`, data);
    },

    delete: async (id) => {
        return axios.delete(`/newsletters/${id}`);
    },
};

export default newsletterService;